import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";

export function CarCardSkeleton() {
  return (
    <Card className="overflow-hidden rounded-[24px] border-border bg-card backdrop-blur-sm">
      {/* Image skeleton */}
      <div className="relative aspect-[4/3] overflow-hidden rounded-t-[24px]">
        <Skeleton className="h-full w-full bg-muted" />
      </div>

      <CardContent className="space-y-2 p-4">
        {/* Brand logo + title + year */}
        <div className="flex items-center gap-3">
          <Skeleton className="h-8 w-8 rounded-full bg-muted" />
          <Skeleton className="h-5 flex-1 bg-muted" />
          <Skeleton className="h-6 w-12 rounded-full bg-muted" />
        </div>

        {/* Mileage, location, price row */}
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-20 bg-muted" />
          <Skeleton className="h-4 w-24 bg-muted" />
          <Skeleton className="h-6 w-28 bg-muted" />
        </div>

        {/* Button */}
        <Skeleton className="h-10 w-full rounded-md bg-muted" />
      </CardContent>
    </Card>
  );
}
